import React from "react";

// Generic input handler
const ArrearsSenventhForm5 = ({ formData, setFormData, onFormDataChange, onBack, onSubmit }) => {
  const handleInputChange = ({ target: { name, value } }) => {
    onFormDataChange({ [name]: value });
  };

  return (
    <div className="google_forms">
      <div className="forms">
        <form>
          <label>
            Any Special Note you want to add on top of output result:
            <input
              type="text"
              name="specialNote"
              value={formData.specialNote || ""}
              onChange={handleInputChange}
            />
          </label>

          {/* You can add a submit button here if needed */}
        
          <button onClick={onBack}>Back</button>

          <button class="submit-button" onClick={onSubmit}>Submit</button>

        </form>
      </div>
    </div>
  );
};

export default ArrearsSenventhForm5;
